import { openDB, IDBPDatabase } from "idb";
import { dbSchema } from "./schema";

export type OfflineDB = IDBPDatabase<unknown>;

export const dbPromise = openDB(dbSchema.name, dbSchema.version, {
  upgrade(db) {
    Object.entries(dbSchema.stores).forEach(([storeName, config]) => {
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, config);
      }
    });
  },
});
